module.exports = __webpack_public_path__ + "media/images/athletes/2119-e5afbd71d60c5a21842b475ff7bc4ecc.png";